import { useScrollReveal } from '../hooks/useScrollReveal';
import { useParallax } from '../hooks/useParallax';

const fiveCapabilities = [
  '结构可理解',
  '证据可回看',
  '维度可诊断',
  '分档可验证',
  '建议可执行',
];

export default function P45WrapUp({ forceVisible = false }: { forceVisible?: boolean }) {
  const { ref: titleRef, isVisible: titleVisible } = useScrollReveal(0.12, forceVisible);
  const { ref: orb1Ref, offset: orb1Y } = useParallax(0.06);
  const { ref: orb2Ref, offset: orb2Y } = useParallax(-0.05);

  return (
    <div className="relative min-h-screen flex flex-col justify-center overflow-hidden">
      {/* 三层背景光效 */}
      <div ref={orb1Ref} className="absolute top-20 right-24 w-[380px] h-[380px] rounded-full bg-primary-100/14 blur-[130px] pointer-events-none" style={{ transform: `translateY(${orb1Y}px)` }} />
      <div ref={orb2Ref} className="absolute bottom-28 left-12 w-[400px] h-[400px] rounded-full bg-accent-100/12 blur-[120px] pointer-events-none" style={{ transform: `translateY(${orb2Y}px)` }} />
      <div className="absolute top-1/2 left-1/3 w-[300px] h-[300px] rounded-full bg-secondary-200/20 blur-[140px] pointer-events-none animate-orb-float-3" />

      <div className="relative z-10 w-full max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16 py-12 md:py-16">
        <div ref={titleRef} className="text-center mb-8 md:mb-10">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full glass-gold border-accent-200/30 mb-5">
            <span className="gold-dot" />
            <span className="text-lg font-body font-semibold text-accent-600 uppercase tracking-[0.15em]">第三部分小结</span>
          </div>
          <h2 className={`font-heading text-5xl md:text-6xl lg:text-7xl font-bold text-foreground-950 leading-tight transition-all duration-1000 delay-100 ${titleVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
          >
            把课堂转化为
          </h2>
          <h2 className={`font-heading text-5xl md:text-6xl lg:text-7xl font-bold leading-tight transition-all duration-1000 delay-150 ${titleVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
          >
            <span className="bg-gradient-to-r from-primary-500 to-accent-500 bg-clip-text text-transparent">结构、证据、评价与改进</span>
          </h2>
        </div>

        {/* 五项能力 */}
        <div className="max-w-4xl mx-auto mb-6 md:mb-8 transition-all duration-1000 delay-400">
          <div className="p-7 rounded-2xl glass-strong border-primary-200/30">
            <h3 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-5 text-center">评价结果必须具备五项能力</h3>
            <div className="flex flex-wrap items-center justify-center gap-3 md:gap-4">
              {fiveCapabilities.map((cap) => (
                <span key={cap} className="px-5 py-3 rounded-full glass border-white/50 text-xl md:text-2xl font-body font-semibold text-foreground-950">
                  {cap}
                </span>
              ))}
            </div>
          </div>
        </div>

        {/* 连接下一页 */}
        <div className="max-w-2xl mx-auto text-center transition-all duration-1000 delay-900">
          <div className="inline-flex items-center gap-2.5 px-6 py-3.5 rounded-xl glass-gold border-accent-200/30">
            <i className="ri-arrow-right-line text-accent-500 text-lg" />
            <span className="text-lg font-body text-foreground-950">
              进入第四部分：<strong className="text-primary-700">应用服务与质量跟踪</strong>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}